import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {TextArea, FormLayout, EmployeeNameWithAvatar, Select2, Input} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';
import {formatTimeOffAmount} from 'main/tools';

const AvailableAmountMessage = observer(({adjustmentAccount, uiState}) => {
  const type = uiState.typeById(adjustmentAccount.typeId);

  return (
    <FormattedMessage id='time_off.account_summaries.AVAILABLE_AMOUNT'
      values={{
        amount: formatTimeOffAmount(adjustmentAccount.adjustedAvailable(type), type.unit),
        type: adjustmentAccount.typeName
      }}
    />
  );
});

const BalanceAdjustmentModal = observer(({uiState}) => {
  const {adjustmentAccount, adjustmentNotes, errors} = uiState;
  if (!adjustmentAccount) return null;

  return (
    <Modal isOpen={uiState.balanceAdjustmentModalOpen} onHide={() => uiState.closeBalanceAdjustmentModal()} size='sm'>
      <div className='h2 mb3'>
        <FormattedMessage id='time_off.account_summaries.Adjust Time-Off Balance'/>
      </div>
      <FormLayout>
        <EmployeeNameWithAvatar size='md' employee={adjustmentAccount.employee} />
        <div>
          <Input
            value={adjustmentAccount.adjustment}
            onChange={e => adjustmentAccount.merge({adjustment: e.target.value})}
            label='time_off.account_summaries.Adjust by'
            errorMessage={errors.adjustment}
            connectedRight={
              <Select2
                value={adjustmentAccount.adjustBy}
                onChange={e => adjustmentAccount.merge({adjustBy: e.target.value})}
              >
                <option value={'days'}><FormattedMessage id='time_off.account_summaries.Days'/></option>
                <option value={'hours'}><FormattedMessage id='time_off.account_summaries.Hours'/></option>
              </Select2>
            }
          />
          <div className='jumbo' style={{paddingTop: '4px'}}>
            <AvailableAmountMessage adjustmentAccount={adjustmentAccount} uiState={uiState} />
          </div>
        </div>
        <TextArea
          value={adjustmentNotes}
          onChange={e => uiState.updateAdjustment(e.target.value)}
          label='time_off.account_summaries.Adjustment notes'
        />
      </FormLayout>
      <ModalButtons
        onSave={() => uiState.saveBalanceAdjustment()}
        onCancel={() => uiState.closeBalanceAdjustmentModal()}/>
    </Modal>
  );
});

export default BalanceAdjustmentModal;
